import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { RoutingsService } from '../../Services/API';
import { MutationKeys, QueryKeys } from '../types';

export const useDeleteRoutingById = (extraOptions?: UseMutationOptions<void, unknown, string>) => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.deleteRouting],
    async (routingId: string) => {
      return RoutingsService.routingsControllerDeleteRouting({ id: routingId });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchRoutings] });
        toast.success('Le routage a été supprimé avec succès');
      },
      onError: () => {
        toast.error('Erreur lors de la suppression du routage');
      },
      ...extraOptions,
    }
  );
};
